module.exports = __webpack_public_path__ + "media/images/heroSlider2-61e03e0972f8109a234289a52227fc8e.jpg";